import React from 'react';

const HamburgerIcon = () => {
  return (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="1.25" y1="-1.25" x2="15.75" y2="-1.25" transform="matrix(1 0 0 -1 1 14)" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M2 9L14 9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M1.60449 2H12.9998H1.60449Z" fill="currentColor"/>
      <path d="M1.60449 2H12.9998" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  );
};

export default HamburgerIcon;
